import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * /visual-language/* is static HTML served by vite-plugin-visual-language (not React).
 * Client-side navigations must hard-reload so Vite/static hosting serves the file.
 */
export function VisualLanguageStaticRedirect() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    const base = (import.meta.env.BASE_URL || '/').replace(/\/$/, '');
    const root = `${base}/visual-language`;
    const isRoot = pathname === root || pathname === `${root}/`;
    const target = isRoot ? `${root}/viewer.html` : pathname;
    window.location.replace(`${target}${search}${hash}`);
  }, [pathname, search, hash]);

  return (
    <p className="text-sm text-charcoal-600 p-4" role="status">
      Opening Diagram Engine…
    </p>
  );
}
